
<div style="position: relative">
    <v-btn
        color="primary"
        fab
        small
        dark
        bottom
        right
        absolute
        style="margin-bottom: 30px; margin-right: 70px"
        @click = "onMailToggle"
    >
        <v-icon>{{ showMailSlide ? 'mdi-close' : 'mdi-email-outline' }}  </v-icon>
    </v-btn>

    <d-inc-history
        v-if      = "incident"
        :incident = "incident"
        v-model   = "history"
    />

    <c-dms-viewer-card
        v-model   = "document.show"
        :document = "document.selected"
        @close    = "onCloseDocument"
        @assigned = "onAssigned"
    />

    <v-expand-x-transition>
        <v-card elevation="10" v-show="showMailSlide" class="dialog-border " style="position: absolute; width: 930px; height: 940px; right: 73px; top: 5px; z-index: 1">
            <div class="w-100 h-100 white">
                <c-inc-mail-editor
                    :mail        = "mail"
                    :incident    = "incident"
                    :step        = "index"
                    :unit        = "unit"
                    :units       = "units"
                    @sended      = "onSended"
                />

            </div>
        </v-card>
    </v-expand-x-transition>

    <c-app-content
        :sites           = "units"
        :search-on-focus = "false"
        @initialized     = "onInitialized"
    >
        <template v-slot:content>
            <div v-if="incident" style="display: flex; margin-top: 0" @keyup="onKeyup" >
                <inc-side-menu
                    :sites           = "units"
                    :incident        = "incident"
                    :clipboard-entry = "clipboardEntry"
                    :index           = "index"
                    @history         = "onHistory"
                    @save            = "onSave"
                    @delete          = "onDelete"
                    @undelete        = "onUnDelete"
                    @refresh         = "onRefresh"
                    @email           = "onMail"
                    @typechanged     = "onChange"
                    @clipboard       = "onClipboard"
                    @clipboardremove = "onClipboardRemove"
                />
                <v-stepper
                    v-model   = "currentSequence"
                    @change   = "onStepChanged"
                    class     = "w-100"
                    :key      = "forceUpdate"
                    :outlined = "false"
                    non-linear
                >
                    <!-- Previous incident button -->
                    <div
                        class="stepper-prev"
                        v-if="incident.prev"
                    >
                        <v-tooltip bottom >
                            <template v-slot:activator="{ on, attrs }">
                                <a
                                    class  = "stepper-nav-btn"
                                    @click = "onGoto(incident.prev.id)"
                                    v-bind = "attrs"
                                    v-on   = "on"
                                >
                                    <i class="fas fa-chevron-left primary--text"></i>
                                </a>
                            </template>
                            <span>{{ incident.prev.name }}</span>
                        </v-tooltip>
                    </div>
                    <!-- Previous incident button -->

                    <div class="step-incident-id">ID {{ incident.id }}</div>
                    <v-stepper-header class="inc-stepper">
                        <template v-for="(data, index) in incident.data">
                            <v-stepper-step
                                :key      = "index + '-step'"
                                :step     = "data.sequence"
                                :editable = "data.sequence <= maxValid"
                                v-show    = "data.visible===true"
                                :color    = "validstate[index] ? 'primary' : errorClass"
                                ref       = "stepheader"
                            >
                                <!-- Step button -->
                                <div style="display: flex; align-items: center">
                                    <!-- Step name -->
                                    <div :class="isCurrent(data)?'primary--text':''" >
                                        {{ incidentType.steps[index].name }}
                                    </div>
                                    <c-clipboard-chip
                                        v-if="clipboard(data)"
                                    />
                                    <!-- Step name -->

                                    <div class="primary white--text lm3-chip pa-2 ml-2" v-if="incident.lmVersion === '3.9'">
                                        LM3
                                    </div>

                                    <!-- Step status icon -->
                                    <div>
                                        <v-icon
                                            class="step-icon"
                                            :class="isCurrent(data)?'primary--text':''"
                                        >
                                            {{ stepStatus (data.sequence) }}
                                        </v-icon>
                                    </div>
                                    <!-- Step status icon -->

                                    <!-- incident deleted chip -->
                                    <div v-if="incident.deleted && index === 0" class="deleted-chip ml-2 error white--text" >
                                        Gelöscht
                                    </div>
                                    <!-- incident deleted chip -->

                                    <!-- Bid Overview -->
                                    <div v-if="isTemplate (index,  'bid')" class="v-flex">
                                        <div
                                            v-if   = "isFullMaintenance"
                                            class  = "full-maintenance ml-2 mr-0"
                                            :class = "isCurrent(data)? 'primary white--text' : 'chip-inactive'"
                                        >
                                            Vollwartung
                                        </div>
                                    </div>
                                    <!-- Bid Overview -->

                                    <inc-bid-overview
                                        v-if   = "isBidsNecessary (data)"
                                        :data  = "data"
                                        :color = "isCurrent(data)? 'primary' : 'rgba(0,0,0,.38)'"
                                        class  = "ml-2"
                                    />

                                    <!-- Step attachments -->
                                    <div>
                                        <c-dms-menu-incident
                                            v-if="data.id"
                                            :step-data-id = "data.id"
                                            :category     = "incidentType.steps[index].stepClass"
                                            :step-name    = "incidentType.steps[index].name"
                                        />
                                    </div>
                                    <!-- Step attachments -->

                                    <div v-if = "index === 0 && warranties">
                                        <inc-warranty-button
                                            :warrenties = "warranties"
                                            ref         = "warrantyButton"
                                        />
                                    </div>

                                    <div v-if="index === 0 && unit && modernizationDate" class="primary modernization-chip">
                                        {{ modernizationDate.type }} {{ modernizationDate.date }}
                                    </div>

                                </div>
                                <!-- Step button -->
                                <div
                                    v-if="!loading && data.sequence > maxValid"
                                    class="step-blocked error-background white--text"
                                >
                                    Bitte {{ maxValid }} abschließen
                                </div>
                            </v-stepper-step>
                            <v-divider
                                :key="index"
                                v-show="data.visible===true"
                            />
                        </template>

                        <!-- Next incident button -->
                        <div
                            class="stepper-next"
                            v-if="incident.next"
                        >
                            <v-tooltip bottom >
                                <template v-slot:activator="{ on, attrs }">
                                    <a
                                        class  = "stepper-nav-btn"
                                        @click = "onGoto(incident.next.id)"
                                        v-bind = "attrs"
                                        v-on   = "on"
                                    >
                                        <i class="fas fa-chevron-right primary--text"></i>
                                    </a>
                                </template>
                                <span>{{ incident.next.name }}</span>
                            </v-tooltip>
                        </div>
                        <!-- Next incident button -->
                    </v-stepper-header>

                    <v-stepper-items>
                        <drop
                            class        = "cut"
                            @drop        = "onDrop"
                            mode         = "cut"
                            accepts-type = "inb-message-selectable"
                        >
                            <v-stepper-content
                                v-for = "(data, index) in incident.data"
                                :key  = "`${index}-content`"
                                :step = "data.sequence"
                            >
                                <div class="step-panel" v-if="isTemplate(index, 'assessment')">
                                    <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                        <inc-assessment
                                            :incident  = "incident"
                                            :data      = "data"
                                            :bus       = "bus"
                                            :step      = "incidentType.steps[index]"
                                            :index     = "index"
                                            :changes   = "changes"
                                            ref        = "step"
                                            @save      = "onSave"
                                            @postponed = "onPostponed"
                                            @pasted    = "onPasted"
                                            @refresh   = "onRefreshData"
                                            @validated = "onStepValidated"
                                            @attached  = "onAttached"
                                            @journal   = "onCloseDocument"
                                        />
                                    </v-form>
                                </div>
                                <div class="step-panel" v-if="isTemplate(index, 'issue')">
                                    <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                        <inc-issue
                                            :incident  = "incident"
                                            :data      = "data"
                                            :step      = "incidentType.steps[index]"
                                            :index     = "index"
                                            :changes   = "changes"
                                            ref        = "step"
                                            @save      = "onSave"
                                            @pasted    = "onPasted"
                                            @refresh   = "onRefreshData"
                                            @validated = "onStepValidated"
                                            @sendmail  = "onSendMail"
                                            @journal   = "onCloseDocument"
                                        />
                                    </v-form>
                                </div>
                                <div class="step-panel" v-if="isTemplate(index, 'invoice')">
                                    <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                        <inc-invoice
                                            :incident = "incident"
                                            :sites    = "units"
                                            :data     = "data"
                                            :step     = "incidentType.steps[index]"
                                            :bus      = "bus"
                                            :index    = "index"
                                            ref       = "step"
                                            @refresh  = "onRefreshData"
                                            @save     = "onSave"
                                            @sendmail = "onSendMail"
                                            @sync     = "onSync"
                                            @journal   = "onCloseDocument"
                                        />
                                    </v-form>
                                </div>
                                <div class="step-panel" v-if="isTemplate(index, 'bid')">
                                    <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                        <inc-bids
                                            :incident  = "incident"
                                            :data      = "data"
                                            :step      = "incidentType.steps[index]"
                                            :bus       = "bus"
                                            :index     = "index"
                                            :changes   = "changes"
                                            ref        = "step"
                                            @save      = "onSave"
                                            @pasted    = "onPasted"
                                            @validated = "onStepValidated"
                                            @sendmail  = "onSendMail"
                                            @sync      = "onSync"
                                            @journal   = "onCloseDocument"
                                            @refresh   = "onRefreshData"
                                            @notice    = "onInitNotice"
                                        />
                                    </v-form>
                                </div>
                                <div class="step-panel" v-if="isTemplate(index, 'mixedinvoice')">
                                    <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                        <inc-mixed-invoice
                                            :incident    = "incident"
                                            :data        = "data"
                                            :step        = "incidentType.steps[index]"
                                            :bus         = "bus"
                                            :index       = "index"
                                            ref          = "step"
                                            @save        = "onSave"
                                            @validated   = "onStepValidated"
                                            @sendmail    = "onSendMail"
                                            @refresh     = "onRefreshData"
                                        />
                                    </v-form>
                                </div>
                                <div class="step-panel" v-if="isTemplate(index, 'maintenance')">
                                    <v-form :ref="data.sequence" class="w-100" v-model="validstate[index]">
                                        <inc-maintenance
                                            :incident    = "incident"
                                            :data        = "data"
                                            :step        = "incidentType.steps[index]"
                                            :bus         = "bus"
                                            :index       = "index"
                                            ref          = "step"
                                            @save        = "onSave"
                                            @validated   = "onStepValidated"
                                            @sendmail    = "onSendMail"
                                        />
                                    </v-form>
                                </div>
                            </v-stepper-content>
                        </drop>
                    </v-stepper-items>
                </v-stepper>
                <transition name="fade">
                    <div class="app-side-r-buttons" v-if="notice">
                        <c-side-button
                            v-model = "showNotice"
                            :left   = "false"
                            @click  = "onNotice"
                            :title  = "$t('main.inc.notice')" />
                    </div>
                </transition>
           </div>
        </template>
    </c-app-content>
</div>
